module.exports = __webpack_public_path__ + "static/media/SEAADE-logo.a8ecb4e0.svg";